module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cDIUY"))).then(() => parcelRequire('2KbAe'));